import React, {PropTypes} from 'react';
import {squadComparator} from 'shared/util/squadComparator';
import OrderReviewSquadItem from './OrderReviewSquadItem.jsx';

const OrderReviewSquadList = ({
  eventsInCart,
  qtyNotEditable,
  onRemoveSquadItem,
  onRemoveVirtualEvent,
  onEventSquadFeesClick,
  onQuantityChange,
  onVirtualEventQuantityChange
}) => (
  <div>
  { eventsInCart.length ?
    <div className="list-group">
      {
        eventsInCart.sort(squadComparator)
        .map((item, index) => (
          <OrderReviewSquadItem
            key={index}
            {...item}
            qtyNotEditable={qtyNotEditable}
            onSquadFeesClick={onEventSquadFeesClick}
            onQuantityChange={onQuantityChange}
            onVirtualEventQuantityChange={onVirtualEventQuantityChange}
            onRemoveSquadItem={onRemoveSquadItem}
            onRemoveVirtualEvent={onRemoveVirtualEvent}
          />
        ))
      }
    </div>
    : null
  }
  </div>
);

OrderReviewSquadList.defaultProps = {
  eventsInCart: []
};

OrderReviewSquadList.propTypes = {
  eventsInCart: PropTypes.arrayOf(PropTypes.object),
  qtyNotEditable: PropTypes.bool,
  onEventSquadFeesClick: PropTypes.func,
  onQuantityChange: PropTypes.func,
  onVirtualEventQuantityChange: PropTypes.func,
  onRemoveSquadItem: PropTypes.func,
  onRemoveVirtualEvent: PropTypes.func
};

export default OrderReviewSquadList;



// WEBPACK FOOTER //
// ./src/features/shared/OrderReviewSquadList.jsx